<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <template v-if="haveServiceAccount && haveServiceAccountContract">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.channel_list') }}</h3>
                    <div class="page-header-action-group">
                        <router-link :to="{ name: 'cms-channels-create' }" class="btn btn__primary" v-if="haveOwnerRight"><i class="icon icon-sm icon-add"></i>{{ $t('words.create_channel') }}
                        </router-link>
                    </div>
                </div>
                <div class="page-sub-header clearfix">
                    <form class="form-inline pull-left">
                        <div class="control-group">
                            <label for="live_status" class="sr-only">{{ $t('words.live_status')}}</label>
                            <select id="live_status" name="live_status" :placeholder="$t('words.live_status')" v-model="list_conditions.live_status">
                                <option value="">{{$t('words.live_status')}}</option>
                                <option value="all">{{ $t('words.all') }}</option>
                                <option value="on">{{ $t('words.live_status_on') }}</option>
                                <option value="off">{{ $t('words.live_status_off') }}</option>
                            </select>
                        </div>
                        <div class="control-group">
                            <label for="shared_status" class="sr-only">{{ $t('words.shared_status') }}</label>
                            <select id="shared_status" name="shared_status"  :placeholder="$t('words.shared_status')" v-model="list_conditions.shared_status">
                                <option value="">{{ $t('words.shared_status') }}</option>
                                <option value="all">{{ $t('words.all') }}</option>
                                <option value="on">{{ $t('words.shared_status_on') }}</option>
                                <option value="off">{{ $t('words.shared_status_off') }}</option>
                            </select>
                        </div>
                    </form>
                    <form class="pull-right" @submit.prevent="changeConditions">
                        <label class="sr-only" for="keyword">{{ $t('words.search') }}</label>
                        <input type="text" id="keyword" class="form-control form__search" :placeholder="$t('paragraphs.placeholder_search')" v-model="list_conditions.keyword">
                    </form>
                </div>
            </div>
            <div class="page-action-group">
                <div class="btn-toolbar" role="toolbar">
                    <div class="btn-group mr-2">
                        <button :class="{btn: true, 'btn-icon': true, 'active': list_mode}" @click="changeListMode(true)"><i class="icon icon-list"></i></button>
                        <button :class="{btn: true, 'btn-icon': true, 'active': !list_mode}" @click="changeListMode(false)"><i class="icon icon-grid"></i></button>
                    </div>
                    <button class="btn mr-2" @click="doTrashChannels" v-if="haveManagerRight && (channels.data.length > 0)">{{ $t('words.hide_channels') }}</button>
                    <button class="btn mr-2" @click="showHiddenChannelsModal()" :disabled="trashed_channels.meta.total === 0" v-if="haveManagerRight">{{ $t('words.hidden_channel_list') }}<span class="hidden__channel__count"  v-if="trashed_channels.meta.total > 0">({{ trashed_channels.meta.total }})</span></button>
                    <div class="btn-group mr-2">
                        <button class="btn" @click="doDisableStatus" v-if="haveManagerRight && (channels.data.length > 0)">{{ $t('words.disable') }}</button>
                        <button class="btn" @click="doEnableStatus" v-if="haveManagerRight && (channels.data.length > 0)">{{ $t('words.enable') }}</button>
                    </div>
                    <button class="btn btn-icon" @click="doRefresh"><i class="icon icon-refresh"></i></button>
                </div>

                <nav aria-label="Page navigation" class="ml-auto">
                    <ul class="pagination">
                        <li class="page-info">
                            {{ $t('paragraphs.page_navigation', { total: channels.meta.total, from: ((channels.meta.current_page - 1) * channels.meta.per_page + 1), to: (channels.meta.current_page === channels.meta.last_page ? channels.meta.total : channels.meta.per_page * channels.meta.current_page)}) }}
                        </li>
                        <li :class="{'page-item': true, disabled: !channels.links.prev }">
                            <button class="page-link" aria-label="Previous" @click="loadChannels(channels.links.prev)" v-if="channels.links.prev">
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                            <button class="page-link" aria-label="Previous" v-else>
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                        </li>
                        <li :class="{'page-item': true, disabled: !channels.links.next }">
                            <button class="page-link" aria-label="Next" @click="loadChannels(channels.links.next)" v-if="channels.links.next">
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                            <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="page-body">
                <div class="table--responsive" v-if="list_mode">
                    <table class="channelList__table">
                        <colgroup>
                            <col width="1%">
                            <col width="25%">
                            <col width="25%">
                            <col width="25%">
                            <col width="1%">
                            <col width="1%" v-if="concurrentlyViewerLimitAvailable">
                            <col width="1%" v-if="useFileToLive || useWebRtc">
                            <col width="1%" v-if="chattingAvailable">
                            <col width="1%">
                            <col width="25%">
                            <col>
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                        </colgroup>
                        <thead>
                        <tr>
                            <th rowspan="2" class="select-item cell__checkbox">
                                <div class="form-checkbox">
                                    <input type="checkbox" id="select_all" :value="true" v-model="selectAll">
                                    <label for="select_all"></label>
                                </div>
                            </th>
                            <th rowspan="2">
                                <span class="btn-order" @click="changeOrder('key_desc')">
                                    {{ $t('words.key') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'key_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'key_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th rowspan="2">
                                <span class="btn-order" @click="changeOrder('customer_code_desc')">
                                   {{ $t('words.customer_code') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'customer_code_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'customer_code_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th rowspan="2" class="channel-name">
                                <span class="btn-order" @click="changeOrder('title_desc')">
                                    {{ $t('words.channel_name') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'title_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'title_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th rowspan="2">{{ $t('words.live_counts') }}</th>
                            <th rowspan="2" v-if="concurrentlyViewerLimitAvailable">{{ $t('words.concurrently_viewer_limit') }}</th>
                            <th rowspan="2">{{ $t('words.channel_kind') }}</th>
                            <th rowspan="2" v-if="chattingAvailable">{{ $t('words.chatting') }}</th>
                            <th rowspan="2">{{ $t('words.status') }}</th>
                            <th colspan="3" class="text-center">{{ $t('words.latest_live_broadcast') }}</th>
                            <th rowspan="2">{{ $t('words.copy') }}</th>
                            <th rowspan="2" class="actions">{{ $t('words.edit') }}</th>
                        </tr>
                        <tr>
                            <th>{{ $t('words.title_and_creator') }}</th>
                            <th>{{ $t('words.started_at') }}/{{ $t('words.ended_at') }}</th>
                            <th>{{ $t('words.accumulate_viewers') }}</th>
                        </tr>
                        </thead>
                        <tbody v-if="channels.load && (channels.meta.total !== 0)">
                        <ListItem :channel="channel" v-for="channel in channels.data" :key="channel.id" @show-channel-cloning-modal="showChannelCloningModal" />
                        </tbody>
                        <tbody v-else-if="channels.load">
                        <tr>
                            <td class="td__message"  :colspan="tableEmptyColspan">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td class="td__message"  :colspan="tableEmptyColspan">
                                <div class="loader"></div>{{ $t('paragraphs.list_loading') }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row channelList__card" v-else>
                    <ListCardItem :channel="channel" v-for="channel in channels.data" :key="channel.id" />
                </div>

                <div class="modal fade" id="hiddenChannelsModal" tabindex="-1" role="dialog" aria-labelledby="hiddenChannelsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="hideChannelModalLabel">{{ $t('words.hidden_channel_list') }}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pb-0">
                                <p>{{ $t('paragraphs.channel.hidden_list_desc') }}</p>
                                <div class="action-group">
                                    <nav aria-label="Page navigation" class="ml-auto">
                                        <ul class="pagination" v-if="trashed_channels.meta.last_page !== 1">
                                            <li class="page-info">
                                            <span>
                                            {{ $t('paragraphs.page_navigation', { total: trashed_channels.meta.total, from: ((trashed_channels.meta.current_page - 1) * trashed_channels.meta.per_page + 1), to: (trashed_channels.meta.current_page === trashed_channels.meta.last_page ? trashed_channels.meta.total : trashed_channels.meta.per_page * trashed_channels.meta.current_page)}) }}
                                            </span>
                                            </li>
                                            <li :class="{'page-item': true, disabled: !trashed_channels.links.prev }">
                                                <button class="page-link" aria-label="Previous" @click="loadTrashedChannels(trashed_channels.links.prev)" v-if="trashed_channels.links.prev">
                                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                                </button>
                                                <button class="page-link" aria-label="Previous" v-else>
                                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                                </button>
                                            </li>
                                            <li :class="{'page-item': true, disabled: !trashed_channels.links.next }">
                                                <button class="page-link" aria-label="Next" @click="loadTrashedChannels(trashed_channels.links.next)" v-if="trashed_channels.links.next">
                                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                                </button>
                                                <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                                <div class="table__wide">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th class="td__checkbox select-item" rowspan="2">
                                                <div class="form-checkbox">
                                                    <input type="checkbox" id="trashed_select_all" v-model="trashedSelectAll">
                                                    <label for="trashed_select_all"></label>
                                                </div>
                                            </th>
                                            <th class="td__minimize">{{ $t('words.key') }}</th>
                                            <th>{{ $t('words.title') }}
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-up':list_conditions.trashed_order === 'title_asc'}" v-if="list_conditions.trashed_order === 'title_asc'" @click="changeTrashedOrder('title_desc')"></i>
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-down':list_conditions.trashed_order === 'title_desc'}" v-else-if="list_conditions.trashed_order === 'title_desc'" @click="changeTrashedOrder('title_asc')"></i>
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true}" v-else @click="changeTrashedOrder('title_desc')"></i>
                                            </th>
                                            <th>{{ $t('words.creator') }}</th>
                                            <th>{{ $t('words.hidden_date') }}
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-up':list_conditions.trashed_order === 'hided_at_asc'}" v-if="list_conditions.trashed_order === 'hided_at_asc'" @click="changeTrashedOrder('hided_at_desc')"></i>
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-down':list_conditions.trashed_order === 'hided_at_desc'}" v-else-if="list_conditions.trashed_order === 'hided_at_desc'" @click="changeTrashedOrder('hided_at_asc')"></i>
                                                <i :class="{'sortable':true, 'fa':true, 'fa-sort':true}" v-else @click="changeTrashedOrder('hided_at_desc')"></i>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="trashed_channels.load && (trashed_channels.meta.total !== 0)">
                                        <tr v-for="trashed_channel in trashed_channels.data" :key="trashed_channel.id">
                                            <td class="td__checkbox">
                                                <div class="form-checkbox">
                                                    <input type="checkbox" :id="`trashed_${trashed_channel.id}`" name="chk_channel" value="true" v-model="trashed_channel.selected" >
                                                    <label :for="`trashed_${trashed_channel.id}`"></label>
                                                </div>
                                            </td>
                                            <td class="td__key td__minimize"><span class="text__key">{{ trashed_channel.key }}</span></td>
                                            <td class="td__channel__name">
                                                <i :class="{icon: true, '': trashed_channel.is_shared, 'icon-lock': !trashed_channel.is_shared}"></i><span class="list__channel__name is-trash" v-tooltip="{ content: trashed_channel.title, html:false }">{{ trashed_channel.title }}</span>
                                            </td>
                                            <td>{{ trashed_channel.latest_live_media_broadcast.live_creator?trashed_channel.latest_live_media_broadcast.live_creator.nickname:'' }}</td>
                                            <td class="td__date td__minimize">{{ renderDatetime(trashed_channel.hided_at) }}</td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else-if="trashed_channels.load">
                                        <tr>
                                            <td colspan="5" class="td__message">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.channel.hidden_list_empty') }}</td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td colspan="5" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="mr-auto">
                                    <button class="btn btn-secondary mr-2" @click="doDestroyChannels" v-if="haveOwnerRight && (trashed_channels.data.length > 0)"><i class="icon icon-trash"></i>{{ $t('words.remove') }}</button>
                                    <button class="btn btn-secondary" @click="doRestoreChannels" v-if="haveManagerRight && (trashed_channels.data.length > 0)"><i class="icon icon-undo"></i>{{ $t('words.restore') }}</button>
                                </div>

                                <div class="ml-auto">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                        {{ $t('words.close') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 채널 복제 모달 -->
            <div class="modal fade" id="channelCloningModal" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">
                                {{ $t('words.channel_clone') }}
                            </h4>
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>

                        <div class="modal-body">
                            <form role="form">
                                <div class="form-group row">
                                    <label class="col-md-3 col-form-label">{{ $t('words.channel_name')}}</label>

                                    <div class="col-md-9">
                                        <input id="titleOfChannelToClone" type="text" class="form-control" maxlength="80" v-model="channelToClone.title">
                                        <span class="invalid-feedback" style="display:block" v-if="channelToClone.meta.errors.title" v-for="error in channelToClone.meta.errors.title" :key="error">{{ error }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-3 col-form-label">{{ $t('words.customer_code')}}<span class="text__star">*</span></label>

                                    <div class="col-md-9">
                                        <input id="customerCodeOfChannelToClone" type="text" class="form-control" maxlength="32" v-model="channelToClone.customer_code">
                                        <small class="form-text text-muted">{{ $t('paragraphs.channel.customer_code_tip')}}</small>
                                        <span class="invalid-feedback" style="display:block" v-if="channelToClone.meta.errors.customer_code" v-for="error in channelToClone.meta.errors.customer_code" :key="error">{{ error }}</span>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ $t('words.cancel')}}
                            </button>
                            <button type="submit" class="btn btn-primary" @click.prevent="doCloneChannel">
                                {{ $t('words.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </template>
            <template v-else-if="haveServiceAccount && !haveServiceAccountContract">
                <div class="page-header-container">
                    <div class="page-header clearfix">
                    </div>
                </div>

                <div class="module">
                    <div class="module-body">
                        <h4>
                            <span class="fa fa-exclamation"></span>
                            {{ $t('paragraphs.has_no_contract') }}
                        </h4>
                        <p>
                            {{ $t('paragraphs.has_no_contract_detail') }}
                        </p>
                    </div>
                </div>
            </template>
            <template v-else>
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">{{ $t('words.has_not_service_account') }}</h3>
                </div>
            </div>

            <div class="module">
                <div class="module-body">
                    <h4>
                        <span class="fa fa-exclamation"></span>
                        {{ $t('paragraphs.has_not_service_account') }}
                    </h4>
                    <p>
                        {{ $t('paragraphs.has_not_service_account_detail') }}
                    </p>
                </div>
            </div>
            </template>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import DateTimeMixin from '../../mixin/DateTimeMixin';
import ChannelConfig from './ChannelConfig';
import ListItem from './ListItem';
import ListCardItem from './ListCardItem';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        ListItem,
        ListCardItem,
    },
    data() {
        return {
            list_mode: true,
            list_conditions: {
                keyword: '',
                live_status: '',
                shared_status: '',
                order: 'id_desc',
                trashed_order: 'id_desc',
                page: 1,
            },
            selectAll: false,
            channels: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
            trashedSelectAll: false,
            trashed_channels: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
            randomInt: null,
            channelToClone: {
                id: null,
                title: null,
                customer_code: null,
                meta: {
                    errors: {},
                },
            },
        };
    },
    created() {
        if (localStorage.getItem('list_mode') === 'card') {
            this.list_mode = false;
        }

        if (typeof localStorage.getItem('query') !== 'undefined') {
            const query = localStorage.getItem('query');
            const params = this.convertQueryToArray(query);

            if (typeof params !== 'undefined') {
                if (typeof params.keyword !== 'undefined') {
                    this.list_conditions.keyword = params.keyword;
                }
                if (typeof params.live_status !== 'undefined') {
                    this.list_conditions.live_status = params.live_status;
                }
                if (typeof params.shared_status !== 'undefined') {
                    this.list_conditions.shared_status = params.shared_status;
                }
                if (typeof params.order !== 'undefined') {
                    this.list_conditions.order = params.order;
                }
                if (typeof params.page !== 'undefined') {
                    this.list_conditions.page = params.page;
                }
            }
        }
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }

        const self = this;
        $('#live_status').selectize({
            maxItems: 1,
            create: true,
            // sortField: 'text',
            onChange(value) {
                self.list_conditions.live_status = value;
                self.changeConditions();
            },
        });
        $('#shared_status').selectize({
            maxItems: 1,
            create: true,
            // sortField: 'text',
            onChange(value) {
                self.list_conditions.shared_status = value;
                self.changeConditions();
            },
        });
    },
    methods: {
        convertQueryToArray(queryStr) {
            if (typeof queryStr !== 'string') {
                return undefined;
            }
            const queryArr = queryStr.replace('?', '').split('&');
            const queryParams = {};
            const qArrLength = queryArr.length;

            for (let q = 0; q < qArrLength; q += 1) {
                const [key, value] = queryArr[q].split('=');
                queryParams[key] = value;
            }

            return queryParams;
        },
        setQueryString() {
            const query = `keyword=${this.list_conditions.keyword}&live_status=${this.list_conditions.live_status}` +
                  `&shared_status=${this.list_conditions.shared_status}&order=${this.list_conditions.order}` +
                  `&page=${this.list_conditions.page}`;

            localStorage.setItem('query', query);
            return query;
        },
        initialize() {
            this.randomInt = new Date().getTime();
            this.loadChannels(this.channelsApiUri);
            this.loadTrashedChannels(this.trashedChannelsApiUri);
        },
        showHiddenChannelsModal() {
            this.loadTrashedChannels(this.trashedChannelsApiUri);

            this.trashedSelectAll = false;
            this.trashed_channels.data = this.trashed_channels.data
                .map(channel => ({
                    ...channel,
                    selected: this.trashed_select_all,
                }));

            $('#hiddenChannelsModal').modal();
        },
        showChannelCloningModal(channel) {
            this.initChannelToClone();
            this.channelToClone.title = `${channel.title}_copy`;
            this.channelToClone.id = channel.id;
            $('#channelCloningModal').modal();
        },
        initChannelToClone() {
            this.channelToClone = {
                id: null,
                title: null,
                customer_code: null,
                meta: {
                    errors: {},
                },
            };
        },
        doCloneChannel(channel) {
            const apiUri = `/cms/${this.selectedServiceAccount.key}/channels/clone`;
            axios.put(apiUri, { id: this.channelToClone.id, title: this.channelToClone.title, customer_code: this.channelToClone.customer_code }).then(() => {
                $('#channelCloningModal').modal('hide');
                // this.changeOrder('id_desc');
                this.loadChannels(this.channelsApiUri);
                this.$toasted.success(this.$t('paragraphs.message.success.clone_channel'));
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.clone_channel'));
                this.channelToClone.meta.errors = error.response.data.errors;
                logger.error(error.response.data.errors);
            });
        },
        loadChannels(channelApi) {
            this.channels.load = false;
            axios.get(channelApi).then((response) => {
                this.channels = response.data;
                this.list_conditions.page = this.channels.meta.current_page;
                this.selectAll = false;
                this.channels.data = this.channels.data
                    .map(channel => ({
                        ...channel,
                        selected: this.select_all,
                        repeat: false,
                        getStats: false,
                    }));

                _.forEach(this.channels.data, (channel) => {
                    if (this.isOnAirByChannel(channel)) {
                        this.calBroadcastDuration(channel);
                    }
                });

                this.channels.load = true;

                this.getSummaryChannelsData();
            });
        },
        loadTrashedChannels(trashedChannelApi) {
            this.trashed_channels.load = false;

            axios.get(trashedChannelApi).then((response) => {
                this.trashed_channels = response.data;
                this.trashedSelectAll = false;
                this.trashed_channels.data = this.trashed_channels.data
                    .map(channel => ({ ...channel, selected: this.trashed_select_all }));

                this.trashed_channels.load = true;
            });
        },
        changeOrder(order) {
            const newOrder = order.match(/^(.*)_(asc|desc)$/);
            const curOrder = this.list_conditions.order.match(/(.*)_(asc|desc)$/);
            if (newOrder.length < 3) {
                return;
            }
            if (curOrder !== null && curOrder.length > 2 && newOrder[1] === curOrder[1]) {
                newOrder[2] = (curOrder[2] === 'asc') ? 'desc' : 'asc';
            }
            this.list_conditions.order = `${newOrder[1]}_${newOrder[2]}`;
            this.list_conditions.page = 1;
            this.loadChannels(this.channelsApiUri);
        },
        changeTrashedOrder(order) {
            const newOrder = order.match(/^(.*)_(asc|desc)$/);
            const curOrder = this.list_conditions.trashed_order.match(/(.*)_(asc|desc)$/);
            if (newOrder.length < 3) {
                return;
            }
            if (curOrder !== null && curOrder.length > 2 && newOrder[1] === curOrder[1]) {
                newOrder[2] = (curOrder[2] === 'asc') ? 'desc' : 'asc';
            }
            this.list_conditions.trashed_order = `${newOrder[1]}_${newOrder[2]}`;
            this.list_conditions.page = 1;
            this.loadTrashedChannels(this.trashedChannelsApiUri);
        },
        doTrashChannels() {
            if (confirm(this.$t('paragraphs.message.confirm.hide_channels'))) {
                const selectedChannelIds = this.channels.data
                    .filter(channel => channel.selected)
                    .map(channel => channel.id);

                if (selectedChannelIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.put(`/cms/${this.selectedServiceAccount.key}/channels/trash`, { selected_ids: selectedChannelIds }).then(() => {
                    this.loadTrashedChannels(this.trashedChannelsApiUri);
                    this.loadChannels(this.channelsApiUri);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.hide_channels'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doEnableStatus() {
            if (confirm(this.$t('paragraphs.message.confirm.enable_channel_status'))) {
                const selectedChannelIds = this.channels.data
                    .filter(channel => channel.selected)
                    .map(channel => channel.id);

                if (selectedChannelIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.put(`/cms/${this.selectedServiceAccount.key}/channels/enable_status`, { selected_ids: selectedChannelIds }).then(() => {
                    this.loadChannels(this.channelsApiUri);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.enable_channel_status'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doDisableStatus() {
            if (confirm(this.$t('paragraphs.message.confirm.disable_channel_status'))) {
                const selectedChannelIds = this.channels.data
                    .filter(channel => channel.selected)
                    .map(channel => channel.id);

                if (selectedChannelIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.put(`/cms/${this.selectedServiceAccount.key}/channels/disable_status`, { selected_ids: selectedChannelIds }).then(() => {
                    this.loadChannels(this.channelsApiUri);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.disable_channel_status'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doRestoreChannels() {
            if (confirm(this.$t('paragraphs.message.confirm.restore_channels'))) {
                const selectedTrashedChannelIds = this.trashed_channels.data
                    .filter(channel => channel.selected)
                    .map(channel => channel.id);

                if (selectedTrashedChannelIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.put(`/cms/${this.selectedServiceAccount.key}/channels/restore`, { selected_ids: selectedTrashedChannelIds }).then(() => {
                    this.loadTrashedChannels(this.trashedChannelsApiUri);
                    this.loadChannels(this.channelsApiUri);
                    $('#hiddenChannelsModal').modal('hide');
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.restore_channels'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doDestroyChannels() {
            if (confirm(this.$t('paragraphs.message.confirm.destroy_channels'))) {
                const selectedChannelIds = this.trashed_channels.data.filter(channel => channel.selected)
                    .map(channel => channel.id);

                if (selectedChannelIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.put(`/cms/${this.selectedServiceAccount.key}/channels`, { selected_ids: selectedChannelIds }).then(() => {
                    this.loadTrashedChannels(this.trashedChannelsApiUri);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.destroy_channels'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doRefresh() {
            this.randomInt = (new Date()).getTime();
            this.loadChannels(`${this.channelsApiUri}&page=${this.channels.meta.current_page}`);
        },
        changeConditions() {
            this.list_conditions.page = 1;
            this.loadChannels(this.channelsApiUri);
        },
        isOnAirByChannel(channel) {
            return typeof channel.latest_live_media_broadcast.is_onair === 'boolean' &&
                channel.latest_live_media_broadcast.is_onair;
        },
        getDuration(started) {
            const startedUtc = this.$moment.utc(started);
            const nowDate = this.$moment().utc();
            let diff;
            diff = nowDate.format('X') - startedUtc.format('X');
            const days = Math.floor(diff / (24 * 60 * 60));
            if (days > 0) {
                diff %= (24 * 60 * 60);
            }
            const hours = Math.floor(diff / (60 * 60));
            const hoursStr = (hours < 10) ? `0${hours}` : hours;
            if (hours > 0) {
                diff %= (60 * 60);
            }
            const minutes = Math.floor(diff / 60);
            const minutesStr = (minutes < 10) ? `0${minutes}` : minutes;
            if (minutes > 0) {
                diff %= (60);
            }
            const seconds = diff;
            const secondsStr = (seconds < 10) ? `0${seconds}` : seconds;
            if (days > 0) {
                return `${days}d ${hoursStr}:${minutesStr}:${secondsStr}`;
            }

            return `${hoursStr}:${minutesStr}:${secondsStr}`;
        },
        calBroadcastDuration(channel) {
            const broadcastIns = channel.latest_live_media_broadcast;

            broadcastIns.repeat = setInterval(() => {
                broadcastIns.interval = this.getDuration(broadcastIns.started_at);

                // if (!this.isOnAirByChannel(channel)) {
                //     clearInterval(channel.repeat);
                // }
            }, 1000);
        },
        getSummaryChannelsData() {
            _.forEach(this.channels.data, (channel) => {
                this.getSummaryChannelData(channel);
            });
        },
        getSummaryChannelData(channel) {
            const localChannel = Object.create(channel);
            const apiUrl = `/cms/${this.selectedServiceAccount.key}/statistics/summary_channel/${localChannel.id}`;

            if (typeof localChannel.latest_live_media_broadcast.key !== 'undefined') {
                axios.post(apiUrl, {
                    broadcasts: localChannel.latest_live_media_broadcast.key,
                }).then((response) => {
                    if (typeof response.data.results === 'object' && response.data.results.length >= 1) {
                        localChannel.latest_live_media_broadcast.sum_user = response.data.results[0].sum_user;
                        localChannel.getStats = true;
                    }
                }).catch((error) => {
                    logger.error(error);
                    // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
                });
            }
        },
        changeListMode(change) {
            this.list_mode = change;
            if (this.list_mode) {
                localStorage.setItem('list_mode', 'list');
            } else {
                localStorage.setItem('list_mode', 'card');
            }
        },
        getIdleScreenUrl(url) {
            return `${url}?_bust=${this.randomInt}`;
        },
        showStats(channel) {
            return channel.getStats && (typeof channel.latest_live_media_broadcast.sum_user !== 'undefined');
        },
        isFileLiveChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.PROGRAMMING;
        },
        isWebRtcChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.WEBRTC;
        },
        isCmafChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.CMAF;
        },
        isDisabledChannel(channel) {
            const isDisabledProgrammingChannel = !this.useFileToLive && channel.kind === 1;
            const isDisabledCmafChannel = !this.useCmaf && channel.kind === 3;
            return isDisabledProgrammingChannel || isDisabledCmafChannel;
        },
    },
    computed: {
        channelsApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels` +
                `?order=${this.list_conditions.order}&keyword=${encodeURI(this.list_conditions.keyword)}&live_status=${this.list_conditions.live_status}` +
                `&shared_status=${this.list_conditions.shared_status}&page=${this.list_conditions.page}`;
        },
        trashedChannelsApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels` +
                `?trashed=1&order=${this.list_conditions.trashed_order}`;
        },
        tableEmptyColspan() {
            let columnsCnt = 14;
            if (!this.chattingAvailable) {
                columnsCnt -= 1;
            }
            if (!this.concurrentlyViewerLimitAvailable) {
                columnsCnt -= 1;
            }
            return columnsCnt;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        selectAll(newValue) {
            this.channels.data = this.channels.data
                .map(channel => ({
                    ...channel,
                    selected: newValue,
                }));
        },
        trashedSelectAll(newValue) {
            this.trashed_channels.data = this.trashed_channels.data
                .map(channel => ({
                    ...channel,
                    selected: newValue,
                }));
        },
        list_conditions: {
            handler(newValue) {
                this.setQueryString();
            },
            deep: true,
        },
    },
};
</script>

<style>
.sortable {
    cursor: pointer;
}
</style>
